module.exports = __webpack_public_path__ + "static/media/3.3.3bc6df60.zip";